/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * A collection of possible price origins
 */
export enum EnumPriceOrigin {
    /**
     * No price has been set yet.
     */
    None = 0,
    /**
     * The price was entered manually.
     * The system must not change this value!
     */
    Manual = 1,
    /**
     * The price came from a price list.
     */
    PriceList = 2,
    /**
     * The price came from a fixed value, such as the price in a service.
     */
    Fixed = 3,
    /**
     * An internal value to indicate that this price must be recalculated.
     */
    ForceRecalculate = 99,
}
